import { useMemo } from 'react';

import { useAppDispatch, useAppSelector } from 'state/hooks';
import {
  ODAnalysis,
  copyAnalysis,
  resetAll,
  setAnalysisSegments,
  setODUIMode,
} from 'state/originDestinationSlices';
import {
  selectProject,
  setCurrentAnalysisId,
  setSelectedSegmentId,
} from 'state/workflowSlice';

import { ODUIMode } from 'appConstants';

export function useODUIMode() {
  const dispatch = useAppDispatch();
  const project_slug = useAppSelector(selectProject);

  return useMemo(
    () => ({
      setCreateMode() {
        dispatch(setCurrentAnalysisId(undefined));
        dispatch(setSelectedSegmentId(undefined));
        dispatch(resetAll());
        dispatch(setODUIMode(ODUIMode.Create));
      },
      setViewMode(analysis?: ODAnalysis) {
        dispatch(setODUIMode(ODUIMode.View));
        if (analysis) dispatch(setCurrentAnalysisId(analysis.analysis_id));
        dispatch(setSelectedSegmentId(undefined));
        dispatch(setAnalysisSegments(undefined));
      },
      setInitialMode(closeTaskbar: boolean = true) {
        dispatch(setODUIMode(ODUIMode.View));
        if (closeTaskbar) dispatch(setCurrentAnalysisId(undefined));
      },
      setCopyMode(analysis: ODAnalysis) {
        dispatch(setSelectedSegmentId(analysis.tt_seg_ids[0]));
        dispatch(copyAnalysis(analysis));
        dispatch(setCurrentAnalysisId(undefined));
        dispatch(setODUIMode(ODUIMode.Create));
      },
    }),
    [dispatch, project_slug],
  );
}
